// BM-H4482. Letters before claim linked to this matter, from the Bonsai Pen tool. Renders nothing
// when none are linked, so it costs other matters nothing.
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "../config/api";

const STATE = { intake: "Draft details", handed_back: "Stopped", awaiting_approval: "Waiting for approval",
                returned: "Sent back", approved: "Approved", sent: "Sent" };

export default function LatePaymentMatterCard({ matterRef, apiBase = API }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    let live = true;
    if (!matterRef) return undefined;
    axios.get(`${apiBase}/late-payment`, { params: { matter_ref: matterRef } })
      .then((res) => { if (live) setRows(res.data?.workups || []); })
      .catch(() => { if (live) setRows([]); });
    return () => { live = false; };
  }, [matterRef, apiBase]);

  if (!rows.length) return null;
  return (
    <section className="mt-6 bg-white/[0.02] border border-white/10 rounded-lg p-5" data-testid="late-payment-matter-card">
      <h2 className="text-sm font-semibold text-txt mb-2">Letters before claim</h2>
      <ul className="text-xs text-txt space-y-1">
        {rows.map((r) => (
          <li key={r.id}>
            <Link className="underline" to={`/bonsai-pen/late-payment/${r.id}`}>{r.debtor || "(debtor not named)"}</Link>
            {": "}{STATE[r.state] || r.state}
          </li>
        ))}
      </ul>
    </section>
  );
}
